import { CheckOutlined } from "@ant-design/icons";
import { Button, Input, Space } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { isBlank } from "@/utilities/string";

const ComboBoxCustomEntry = ({
  onAddCustomValue = () => {},
  placeholder = "",
}) => {
  const { t } = useTranslation();
  const [customValue, setCustomValue] = useState("");
  const isCustomValueBlank = isBlank(customValue);

  const onInputKeyUp = (event) => {
    if (event.key === "Enter" && !isCustomValueBlank) {
      onConfirm();
    }
  };

  const onConfirm = (event) => {
    event?.preventDefault();

    onAddCustomValue(customValue.trim());
    setCustomValue("");
  };

  return (
    <Space.Compact
      style={{ padding: "8px", display: "flex", alignItems: "center" }}
    >
      <Input
        placeholder={placeholder || t("global:customValue")}
        onKeyUp={onInputKeyUp}
        value={customValue}
        onChange={(e) => setCustomValue(e.target.value)}
        style={{ width: "calc(100% - 90px)" }}
      />
      <Button
        disabled={isCustomValueBlank}
        type="text"
        icon={<CheckOutlined />}
        onClick={onConfirm}
      >
        {t("global:ok")}
      </Button>
    </Space.Compact>
  );
};

export default ComboBoxCustomEntry;
